export var ERRORS_CODE = {
    ERR_PHONE: 'UREG_ERR_146',
    ERR_AUTH: 'AUTH_ERR_101',
};
export var ERR_GENERIC = {
    message: 'Something went wrong. Please refresh the page and try again.',
};
export var ERR_GENERIC_LATER = {
    message: 'Something went wrong on our end. Please check back later.',
};
export var ERR_PHONE = {
    message: 'This phone number is associated with another account. Please try another number.',
};
export var ERR_INVALID_ZIP = {
    message: 'Please provide a valid zip code.',
};
export var ERR_SAVE = {
    message: 'We’re unable to save your changes. Please try again.',
};
export var ERR_REDIRECT = {
    message: 'We’re redirecting you to sign in to your account.',
};
export var ERR_FILTER = {
    message: 'We were unable to load your filters. Refresh your page and try again.',
};
